import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'applications-panel',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    navBtn: {},
    activeNavBtn: {},
  }),
  options
);

export default useStyles;
